import script from "./modal-base.vue?vue&type=script&setup=true&lang=ts"
export * from "./modal-base.vue?vue&type=script&setup=true&lang=ts"

import "./modal-base.vue?vue&type=style&index=0&id=dedafd38&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dedafd38"]])

export default __exports__